import PropTypes from 'prop-types';
import React from 'react';
import asButton from '../decorator/asButton';
import ButtonComponent from './Button';
import IconComponent from './Icon';
import './Modal.css';
import TitleComponent from './Title';

const Modal = React.memo(
  ({ visible, width, type, icon, modalTitle, text, confirmEvent, cancelEvent, children }) => (
    <div className="modal" data-modal-visible={visible}>
      <main className={`w${width}`} data-modal-type={type}>
        <header>
          {modalTitle && <TitleComponent icon={icon} title={modalTitle} trivial />}
          <aside {...asButton(undefined, cancelEvent)}>
            <IconComponent src="icon-delete-1" caption="Close" />
          </aside>
        </header>
        {text && <article>{text}</article>}
        <footer>
          {children}
          {!children && (
            <>
              <ButtonComponent
                id={undefined}
                clickButtonEvent={confirmEvent}
                icon="icon-check-circle-1"
                title="OK"
              />
              <ButtonComponent
                id={undefined}
                clickButtonEvent={cancelEvent}
                icon="icon-delete-1"
                title="Cancel"
              />
            </>
          )}
        </footer>
      </main>
    </div>
  )
);

Modal.propTypes = {
  visible: PropTypes.bool,
  width: PropTypes.oneOf(['33', '50', '66']),
  type: PropTypes.string,
  icon: PropTypes.string,
  modalTitle: PropTypes.string,
  text: PropTypes.string,
  confirmEvent: PropTypes.string,
  cancelEvent: PropTypes.string
};

Modal.defaultProps = {
  visible: false,
  width: '50',
  type: 'default',
  icon: undefined,
  modalTitle: undefined,
  text: undefined,
  confirmEvent: 'modalConfirm',
  cancelEvent: 'modalCancel'
};

export default Modal;
